

    var displayProducts = function() {
        var storedData = sessionStorage.getItem("allProductsBitcoinEN");
    
        // Funkce pro zobrazení produktů
        var processProductsData = function(productsData) {
            var productsMap = {};
    
            $.each(productsData, function(index, product) {
                productsMap[product.CODE] = product;
            });
            if($('.type-post, .type-page').find('.customProduct').length){
                $('.customProduct').each(function() {
                    var $list = $(this);
                    var codes = $list.attr('data-code').split(',');

                    var $productsDiv = $list.next('.postProduct');
                    if ($productsDiv.length === 0) {
                        $productsDiv = $('<div id="products" class="products products-page products-block postProduct" data-testid="productCards"></div>');
                        $list.replaceWith($productsDiv);
                    }
                    
                    codes.forEach(function(code) {
                        var product = productsMap[code.trim()];
                        if (product) {
                            var productElement = createProductElement(product);
                            $productsDiv.append(productElement);
                        } else {
                            console.error('Žádný produkt nenalezen pro kód: ' + code);
                        }
                    });
                });
            }
            
        };
    
        if (storedData) {
            // Pokud jsou data uložená, zpracujeme je
            var productsData = JSON.parse(storedData);
            processProductsData(productsData);
        } else {
            // Data nejsou v sessionStorage, načteme je pomocí AJAX
            $.getJSON("/user/documents/crypto.json?" + new Date().getMinutes(), function(productsData) {
                sessionStorage.setItem("allProductsBitcoinEN", JSON.stringify(productsData));
                processProductsData(productsData);
            });
        }
    };

    var createProductElement = function(product) {
       // console.log(product)
       if(product.VISIBILITY === 'visible'){
        productImage = product.IMGURL.replace('/orig/', '/detail/')
        productName = product.NAME
        productUrl = product.ORIG_URL
        productPrice = product.PRICE
        var activeFlags = product.FLAGS.FLAG.filter(flag => flag.ACTIVE === "1");
        var newProduct = '<div class="product" data-code="'+product.CODE+'">'
                        newProduct += '<div class="p">'
                            newProduct += '<a href="'+productUrl+'" class="image">'
                            newProduct += '<img src="'+productImage+'" alt="'+productName+'">'
                            if (activeFlags.length > 0) {
                                newProduct += '<div class="flags flags-default">';
                                activeFlags.forEach(flag => {
                                    if(flag.CODE === 'action'){
                                        flagName = 'Akce';
                                        flagColor = '#009447';
                                    }
                                    if(flag.CODE === 'new'){
                                        flagName = 'Novinka';
                                        flagColor = '#902A7D'
                                    }
                                    if(flag.CODE === 'tip'){
                                        flagName = 'Tip';
                                        flagColor = '#0072AD'
                                    }
                                    if(flag.CODE === 'kaspa'){
                                        flagName = 'Kaspa';
                                        flagColor = '#0072ad'
                                    }
                                    if(flag.CODE === 'bugna'){
                                        flagName = 'Bugna';
                                        flagColor = '#f6bd24'
                                    }
                                    if(flag.CODE === 'sedra'){
                                        flagName = 'Sedra';
                                        flagColor = '#902a7d'
                                    }
                                    newProduct += '<span class="flag flag-'+flag.CODE+'" style="background-color:'+flagColor+'">'+flagName+'</span>';
                                });
                                newProduct += '</div>';
                            }
                            newProduct += '</a>'
                            newProduct +='<div class="p-in">'
                                newProduct +='<div class="p-in-in">'
                                    newProduct +='<a href="'+productUrl+'" class="name" data-micro="url">'
                                    
                                        newProduct +='<span data-micro="name" data-testid="productCardName">'+productName+'</span>'

                                    
                                    newProduct +='</a>'
                                   
                                newProduct += '</div>'
                                newProduct +='<div class="p-bottom">'
                                    newProduct +='<div data-micro="offer" data-micro-price="'+productPrice+'" data-micro-price-currency="CZK" data-micro-availability="https://schema.org/InStock">'
                                    
                                        newProduct +='<div class="prices">'
                                            newProduct += '<div class="price price-final" data-testid="productCardPrice">'
                                                newProduct +=  '<strong> '+Number(productPrice).ShoptetFormatAsCurrency()+' </strong>'
                                            newProduct += '</div>'
                                        newProduct +='</div>'
                                    
                                        newProduct += '<div class="p-tools"><a href="'+productUrl+'" class="btn btn-primary">'+detailButton+'</a></div>'
                                        
                                    
                                        newProduct +='</div>'
                                    newProduct +='</div>'
                            newProduct +='</div>'
                            newProduct +='<span class="no-display" data-micro="sku">'+product.CODE+'</span>'
                        newProduct += '</div>'
                    newProduct += '</div>'
        return newProduct;
       }
        
    };

   

    $(document).ready(function() {
        displayProducts();
    });